import clsx from "clsx";

export const CampaignCardWorkspacePill = ({
  workspaceName,
  workspaceCampaignCount,
}: {
  workspaceName?: string;
  workspaceCampaignCount?: number;
}) => {
  if (!workspaceName || !workspaceCampaignCount || workspaceCampaignCount <= 1)
    return null;

  return (
    <div
      className={clsx(
        "typography-body-4-semibold",
        "rounded-[4px] border-none",
        "px-2 py-1",
        "max-w-[400px] truncate",
        "line-clamp-2",
        "bg-black/10 text-black/80"
      )}
    >
      1 of {workspaceCampaignCount} campaigns by {workspaceName}
    </div>
  );
};
